import { atom } from "jotai";

export const appVersionAtom = atom<string | undefined>(undefined);
